var map = {
	"./achievements.js": 14931,
	"./animations.js": 88780,
	"./auth.js": 68985,
	"./bonusslot.js": 93768,
	"./cards.js": 6996,
	"./champions.js": 29971,
	"./chat.js": 19289,
	"./cookieManager.js": 68758,
	"./events.js": 46610,
	"./externalScripts.js": 93418,
	"./gameplay.js": 32707,
	"./index.js": 46515,
	"./kingspath.js": 61416,
	"./missions.js": 69452,
	"./news.js": 6252,
	"./popups.js": 94840,
	"./shop.js": 72171,
	"./sound.js": 6276,
	"./teams.js": 9129,
	"./tournaments.js": 14663,
	"./treasury.js": 28182,
	"./user.js": 12296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78043;